import React from 'react';
import './PageStyles.css';

export default function StoreOwnerTerms() {
  return (
    <div className="legal-page">
      <div className="page-hero hero-gradient">
        <div className="container text-center">
          <span className="section-label" style={{ background: 'rgba(103,183,247,0.15)', color: 'var(--secondary)' }}>Legal</span>
          <h1>Store Owner Terms</h1>
          <p>Last updated: January 1, 2025</p>
        </div>
      </div>
      <section>
        <div className="container">
          <div className="legal-content">
            <h2>1. Store Registration</h2>
            <p>To list your store on Pointfinity, you must complete the onboarding process, provide accurate business information, and pay the applicable onboarding fee. Pointfinity reserves the right to approve or reject any store application.</p>

            <h2>2. Subscription Plans</h2>
            <p>Store owners must subscribe to an active Pointfinity plan to operate their loyalty program. Available plans include Basic ($19/mo), Pro ($49/mo), and Enterprise ($99/mo). Subscriptions auto-renew unless cancelled.</p>

            <h2>3. Loyalty Program Setup</h2>
            <p>Store owners are responsible for:</p>
            <ul>
              <li>Configuring their loyalty point rules accurately</li>
              <li>Ensuring staff are trained on how to use the platform</li>
              <li>Honoring all points earned by customers in their store</li>
              <li>Keeping store information up to date</li>
            </ul>

            <h2>4. Commission on Redemptions</h2>
            <p>Pointfinity charges a commission of 2–3% on the value of points redeemed at your store. This commission is deducted automatically from your monthly settlement. The exact rate depends on your subscription plan and agreement.</p>

            <h2>5. Prohibited Activities</h2>
            <p>Store owners must not:</p>
            <ul>
              <li>Issue fraudulent points or manipulate the rewards system</li>
              <li>Use the platform to promote illegal products or services</li>
              <li>Share their admin credentials with unauthorized parties</li>
              <li>Collect customer data outside of the Pointfinity system</li>
            </ul>

            <h2>6. Data Ownership</h2>
            <p>Customer data collected through Pointfinity remains the joint property of Pointfinity and the store owner. You may not export or use customer data for purposes outside the platform without explicit consent.</p>

            <h2>7. Store Suspension</h2>
            <p>Pointfinity may suspend or terminate a store's account for violation of these terms, non-payment of subscription fees, or fraudulent activity. Suspended stores lose access to all platform features.</p>

            <h2>8. Liability</h2>
            <p>Store owners are responsible for all activities conducted under their account. Pointfinity is not liable for any customer disputes arising from the store's loyalty program policies.</p>

            <h2>9. Amendments</h2>
            <p>These Store Owner Terms may be updated at any time. Continued use of the platform after updates constitutes acceptance of the new terms.</p>

            <h2>10. Contact</h2>
            <p>For store-related inquiries, contact partners@pointfinity.com.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
